/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo } from 'react';

import { FilterDimension } from 'components/FilterDimension';
import { Metrics } from 'components/Incrementality/incrementalityTypes';

import { useOrganization } from 'modules/organization/useOrganization';

import { DSP_ADFORM, DSP_FREEWHEEL } from 'utils/constants';

export const HaloEffectFilter = ({
  haloFilter,
  onChange,
}: {
  haloFilter: string;
  onChange: (data: string) => void;
}) => {
  const { dsp } = useOrganization();

  useEffect(() => {
    // Reset to LEADS if ACTIVITY is selected but DSP is not Adform or FreeWheel
    if (haloFilter === 'ACTIVITY' && dsp !== DSP_ADFORM && dsp !== DSP_FREEWHEEL) {
      onChange(Metrics.LEADS.value);
    }
  }, [dsp, haloFilter]);

  const getOptions = useCallback(
    (items: Record<string, { label: string; value: string }>) =>
      Object.entries(items).map(([key, { label }]) => ({
        label,
        value: key,
      })),
    [],
  );

  const filteredMetrics = useMemo(() => {
    if (dsp === DSP_ADFORM || dsp === DSP_FREEWHEEL) {
      // For Adform/FreeWheel: show all metrics including ACTIVITY
      return Metrics;
    }
    // For other DSPs: exclude ACTIVITY
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ACTIVITY, ...otherMetrics } = Metrics;

    return otherMetrics;
  }, [dsp]);

  return (
    <FilterDimension
      prefixText="Metric:"
      allOptions={getOptions(filteredMetrics)}
      selectedOption={haloFilter}
      onChange={(value) => onChange(value)}
    />
  );
};
